import React, { useEffect, useState } from 'react';
import { Filter } from 'lucide-react';
import { supabase } from '../config/supabase';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

interface CategoryFilterProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryFilter({ selectedCategory, onCategoryChange }: CategoryFilterProps) {
  const [categories, setCategories] = useState<string[]>(['All']);

  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await supabase
        .from('professions')
        .select('category')
        .order('category');

      if (!error && data) {
        // Get unique categories
        const uniqueCategories = ['All', ...new Set(data.map(p => p.category))];
        setCategories(uniqueCategories);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="mb-8 flex items-center gap-4">
      <div className="w-64">
        <Select value={selectedCategory} onValueChange={onCategoryChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select a category" />
          </SelectTrigger>
          <SelectContent>
            {categories.map((category) => (
              <SelectItem key={category} value={category}>
                {category}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <button className="flex items-center px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 text-sm">
        <Filter className="w-4 h-4 mr-1.5" />
        More Filters
      </button>
    </div>
  );
}